<template>
  <el-select
    v-model="val"
    :disabled="disabled"
    filterable
    style="width: 100%"
    @change="handleChange"
  >
    <el-option
      v-for="(item, index) in ops"
      :key="index"
      :label="item.assessSystemName"
      :value="item.assessSystemNo"
    />
  </el-select>
</template>

<script>
import http from '@/plugin/axios'
export default {
  name: 'AssessSystemSelector',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      val: '0000',
      ops: []
    }
  },
  watch: {
    'data.purchaseUnit': {
      handler() {
        this.getOps()
      },
      deep: true
    }
  },
  created() {
    this.getOps()
  },
  methods: {
    getOps() {
      http({
        url: '/examineProcess/getAllAssessSystem',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        params: {
          purchaseUnitNo: this.data.purchaseUnit ?? ''
        }
      }).then(res => {
        this.ops = res
      })
    },
    handleChange(val) {
      const assessSystem = this.ops.find(x => x.assessSystemNo === val)
      if (assessSystem) {
        this.data.assessSystemName = assessSystem.assessSystemName
        this.data.assessSystemId = assessSystem.assessSystemId
      }
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>

</style>
